import { render, staticRenderFns } from "./HomeCards.vue?vue&type=template&id=9b55a90a&scoped=true&"
import script from "./HomeCards.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HomeCards.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HomeCards.vue?vue&type=style&index=0&id=9b55a90a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b55a90a",
  null
  
)

export default component.exports